





































import { Vue, Component, Prop } from 'vue-property-decorator';

type indicatorData = string[]; 

@Component
export default class ConfirmDeletionModal extends Vue {
    @Prop({ default: null }) waterSupplyData!: indicatorData; 

    show() {
      (this.$refs.confirmDeletionModal as any).show();
    }

    confirmDataDeletion() {
      this.$emit('confirm-data-deletion');
      (this.$refs.confirmDeletionModal as any).hide();
    }

    handleHide(evt: any) {
      if (evt.trigger === 'headerclose') {
        this.$emit('close-confirm-deletion-modal');
      }
    }

    handleCancel() {
      this.$emit('close-confirm-deletion-modal');
      (this.$refs.confirmDeletionModal as any).hide();
    }

    capitalize(s: string) {
      if (typeof s !== 'string') return ''
      return s.split("").map((s: string) => s.toUpperCase()).join("") 
    }
};

